/** Map a LotSense deal (+ vehicle fields on the deal row) → BHPH origination form. */

function vehicleCostFromDeal(deal) {
  const invested = parseFloat(
    deal.total_invested_value ?? deal.totalInvestedValue ?? deal.total_cost ?? deal.totalCost
  );
  if (Number.isFinite(invested) && invested > 0) return invested;

  const purchase = parseFloat(deal.purchase_price ?? deal.purchasePrice) || 0;
  const recon = parseFloat(deal.recon_cost ?? deal.reconCost) || 0;
  const transport = parseFloat(deal.transport_cost ?? deal.transportCost) || 0;
  const sum = purchase + recon + transport;
  return sum > 0 ? sum : null;
}

export function mapDealToBhphPrefill(deal) {
  if (!deal) return null;

  const fees = {};
  const docFee = parseFloat(deal.doc_fee);
  if (Number.isFinite(docFee) && docFee > 0) {
    fees.fee1Label = 'Doc fee';
    fees.fee1Amt = String(docFee);
  }

  const tax = parseFloat(deal.sales_tax_amount);
  const taxTitleAmt =
    Number.isFinite(tax) && tax > 0 ? String(tax) : '';

  let saleDate = '';
  if (deal.sale_date) {
    saleDate =
      typeof deal.sale_date === 'string'
        ? deal.sale_date.split('T')[0]
        : new Date(deal.sale_date).toISOString().split('T')[0];
  }

  const trade = parseFloat(deal.trade_in_value);
  const salePrice = parseFloat(deal.sale_price);
  const cost = vehicleCostFromDeal(deal);

  return {
    sourceDealId: deal.id || null,
    buyerName: deal.buyer_name || '',
    buyerStreet: deal.buyer_address || '',
    buyerCity: deal.buyer_city || '',
    buyerState: deal.buyer_state || 'OH',
    buyerZip: deal.buyer_zip || '',
    buyerPhone: deal.buyer_phone || deal.buyer_contact || '',
    buyerEmail: deal.buyer_email || '',
    buyerDl: deal.buyer_dl_number || '',
    buyerDlState: deal.buyer_dl_state || '',
    coBuyerName: deal.co_buyer_name || '',
    coBuyerPhone: deal.co_buyer_phone || '',
    coBuyerEmail: deal.co_buyer_email || '',
    vehYear: deal.year != null ? String(deal.year) : '',
    vehMake: deal.make || '',
    vehModel: deal.model || '',
    vehColor: deal.color || '',
    vehVin: deal.vin || '',
    vehStock: deal.stock_number || '',
    vehOdometer: deal.mileage != null ? String(deal.mileage) : '',
    saleDate,
    cashPrice: Number.isFinite(salePrice) ? String(salePrice) : '',
    tradeAmt: Number.isFinite(trade) && trade > 0 ? String(trade) : '',
    tradeDesc: deal.trade_in_description || deal.trade_desc || '',
    taxTitleAmt,
    costInCar: cost != null ? String(cost) : '',
    declineFee: '10',
    lateFeeStartDays: '5',
    lateFeeRepeatDays: '3',
    serviceContract: false,
    ...fees,
  };
}

export const BHPH_PREFILL_KEY = 'bhph_prefill_v1';

export function stashBhphPrefill(deal) {
  const payload = mapDealToBhphPrefill(deal);
  if (!payload) return;
  sessionStorage.setItem(BHPH_PREFILL_KEY, JSON.stringify(payload));
}

export function takeBhphPrefill() {
  try {
    const raw = sessionStorage.getItem(BHPH_PREFILL_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(BHPH_PREFILL_KEY);
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
